import { CommonModule } from "@angular/common";
import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  Type,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { SafeHtmlPipe } from "app/js/src/pipes/safeHtml.pipe";
@Component({
  selector: "evrideo-evrideo-dialog",
  templateUrl: "./evrideo-dialog.component.html",
  styleUrl: "./evrideo-dialog.component.scss",
  standalone: true,
  imports: [CommonModule, SafeHtmlPipe],
})
export class EvrideoDialogComponent {
  @ViewChild("dialogElement") dialogElement!: ElementRef<HTMLDialogElement>;
  @ViewChild("contentContainer", { read: ViewContainerRef })
  contentContainer!: ViewContainerRef;

  @Input() dialogType: EvrideoDialogType;
  @Input() title!: string;
  @Input() contentText?: string;
  @Input() contentComponent?: Type<any>;

  @Input() confirmButtonText: string;
  @Input() cancelButtonText: string;
  @Input() contentContext?: any;
  @Input() timeout?: number;
  @Input() hideIcon: boolean = false;
  @Input() hideCloseButton: boolean = false;

  @Input() backDropOpacity: number = 0.5;

  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();
  private openPending = false;
  public hideActionButtons: boolean = true;
  public hideCancelButton: boolean = false;
  @HostListener("document:keydown.escape", ["$event"])
  handleEscapeKey(event: KeyboardEvent) {
    if (this.dialogElement && this.dialogElement.nativeElement.open) {
      event.preventDefault();
      this.cancel();
    }
  }

  ngOnInit() {
    this.hideActionButtons = this.confirmButtonText == undefined;
    this.hideCancelButton = this.cancelButtonText == undefined;
  }
  ngAfterViewInit() {
    if (this.contentComponent) {
      this.dialogElement.nativeElement.style.setProperty(
        "--backdrop-opacity",
        `${this.backDropOpacity}`,
      );
      const componentRef = this.contentContainer.createComponent(
        this.contentComponent,
      );
      if (this.contentContext) {
        Object.assign(componentRef.instance, this.contentContext);
      }
    }
    if (this.openPending) {
      this.open();
    }
  }
  updateContent(options: EvrideoDialogOptions) {
    this.dialogType = options.type || this.dialogType;
    if (options.title) this.title = options.title;
    if (options.confirmButtonText)
      this.confirmButtonText = options.confirmButtonText;
    if (options.cancelButtonText)
      this.cancelButtonText = options.cancelButtonText;
    this.hideCloseButton = options.hideCloseButton;
    if (options.content) {
      if (typeof options.content === "string") {
        this.contentText = options.content;
        this.contentComponent = undefined;
      } else {
        this.contentText = undefined;
        this.contentComponent = options.content;
        this.contentContext = options.contentContext || {};

        if (this.contentContainer) {
          this.contentContainer.clear();
          const componentRef = this.contentContainer.createComponent(
            this.contentComponent,
          );
          if (this.contentContext) {
            Object.assign(componentRef.instance, this.contentContext);
          }
        }
      }
    }
    if (options.timeout) {
      setTimeout(() => {
        this.close();
      }, options.timeout);
    }
  }

  open() {
    if (this.dialogElement) {
      this.dialogElement.nativeElement.showModal();
      if (this.hideActionButtons && !this.contentComponent) {
        this.timeout = this.timeout || 2000;
        if (this.timeout > 0) {
          setTimeout(() => {
            this.close();
          }, this.timeout);
        }
      }
    } else {
      this.openPending = true;
    }
  }

  confirm() {
    this.confirmed.emit();
    this.close();
  }

  cancel() {
    this.cancelled.emit();
    this.close();
  }

  protected close() {
    if (this.dialogElement) {
      if (this.hideActionButtons && !this.contentComponent) {
        this.confirmed.emit();
      }
      this.dialogElement.nativeElement.close();
    }
  }
}
export type EvrideoDialogType =
  | "success"
  | "info"
  | "warning"
  | "error"
  | "simple";

export type EvrideoDialogOptions = {
  type: EvrideoDialogType;
  title: string;
  content: string | Type<any>;
  confirmButtonText?: string;
  cancelButtonText?: string;
  hideIcon?: boolean;
  hideCloseButton?: boolean;
  contentContext?: any;
  timeout?: number;
  backDropOpacity?: number;
};
export type EvrideoLoadingDialogOptions = {
  type?: EvrideoDialogType;
  title: string;
  loadingContent: string | Type<any>;
  loadingContentContext?: any;
};
